import { OrgChartNode } from "components/organisms/OrgTree";

export const addNode = (
  tree: OrgChartNode[],
  nodeId: number,
  newNode: OrgChartNode
): OrgChartNode[] => {
  if (nodeId === 0) return [newNode, ...tree];
  return tree.map((node) => {
    if (node.id === nodeId) {
      return {
        ...node,
        children: [newNode],
      };
    }
    if (node?.children?.length > 0) {
      return {
        ...node,
        children: addNode(node.children, nodeId, newNode),
      };
    }
    return node;
  });
};

export const updateNode = (
  tree: OrgChartNode[],
  currentNode: OrgChartNode
): OrgChartNode[] => {
  return tree.map((node) => {
    if (node?.id === currentNode?.id) {
      return {
        ...node,
        ...currentNode,
      };
    }
    if (node?.children?.length > 0) {
      return {
        ...node,
        children: updateNode(node.children, currentNode),
      };
    }
    return node;
  });
};

export const addEmployees = (
  tree: OrgChartNode[],
  nodeId: number,
  employees: OrgChartNode["employees"]
): OrgChartNode[] => {
  return tree.map((node) => {
    if (node.id === nodeId) {
      return {
        ...node,
        employees,
        fetchedEmployee: true,
      };
    }
    if (node?.children?.length > 0) {
      return {
        ...node,
        children: addEmployees(node.children, nodeId, employees),
      };
    }
    return node;
  });
};

export const addDeptManager = (
  tree: OrgChartNode[],
  nodeId: number,
  deptManagers: OrgChartNode["deptManagers"]
): OrgChartNode[] => {
  return tree.map((node) => {
    if (node.id === nodeId) {
      return {
        ...node,
        deptManagers: [...(node?.deptManagers || []), ...(deptManagers || [])],
      };
    }
    if (node?.children?.length > 0) {
      return {
        ...node,
        children: addDeptManager(node.children, nodeId, deptManagers),
      };
    }
    return node;
  });
};

export const deleteDeptManager = (
  tree: OrgChartNode[],
  nodeId: number,
  employeeId: number,
  role: string
): OrgChartNode[] => {
  return tree.map((node) => {
    if (node.id === nodeId) {
      return {
        ...node,
        deptManagers: node.deptManagers?.filter(
          (item) =>
            !(
              Number(item?.employee?.id || 0) === Number(employeeId) &&
              item?.role === role
            )
        ),
      };
    }
    if (node?.children?.length > 0) {
      return {
        ...node,
        children: deleteDeptManager(node.children, nodeId, employeeId, role),
      };
    }
    return node;
  });
};

export const deleteDept = (
  tree: OrgChartNode[],
  nodeId: number
): OrgChartNode[] => {
  return tree
    .map((node) => {
      if (node.id === nodeId) {
        return "" as unknown as OrgChartNode;
      }
      if (node?.children?.length > 0) {
        return {
          ...node,
          children: deleteDept(node.children, nodeId),
        };
      }
      return node;
    })
    .filter(Boolean);
};
